import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CatalogRepositoryService } from '../../services/catalog-repository.service';
import { HelixRoutes } from 'src/app/shared/enums/routes';
import { MetaService } from '@shared/services/meta/meta.service';
import { MobileFiltersModalCatalogComponent } from '../../components/mobile-filters-modal-catalog/mobile-filters-modal-catalog.component';
import { PageSize } from '../../const/catalog-pagination-sizes';
import { TypeNomenclatures } from '../../enums/type-nomenclatyre.enum';
import { RegionsService } from '@shared/services/regions.service';
import { logoSvg } from '@shared/components/footer/constants/logo.svg';
import { NavigationMenuService } from '@shared/services/navigation-menu.service';

@Component({
  selector: 'app-catalog-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CatalogRepositoryService, RegionsService],
})
export class CatalogListComponent implements OnInit, OnDestroy {
  constructor(
    public repository: CatalogRepositoryService,
    protected navigationMenu: NavigationMenuService,
    private metaService: MetaService
  ) {}

  readonly helixLiteLogo = logoSvg;
  readonly HelixRoutes = HelixRoutes;
  readonly PageSize = PageSize;
  readonly MobileFiltersModalComponent = MobileFiltersModalCatalogComponent;
  readonly TypeNomenclatures = TypeNomenclatures;

  private ngUnsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.setMeta();
  }

  private setMeta(): void {
    this.repository.description$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((description) => this.metaService.description(description));

    this.repository.metaTitle$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((metaTitle) => this.metaService.title(metaTitle));
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
